import appState from '../../state/AppStateContainer';

export const inboxSides = () => ({
  purchaser: appState.isPurchasingActive() && !appState.isClientRole(),
  sales: appState.isSalesActive() && !appState.isClientRole(),
});

export const hasInbox = () => Object.values(inboxSides()).some(Boolean);

export const inboxUnreadCount = () => {
  const sides = inboxSides();
  const { project, salesInbox } = appState.getGlobalNotifications();
  return (sides.purchaser ? project : 0) + (sides.sales ? salesInbox : 0);
};
